import {
  GET_QUOTE_FUNNELS_PRICES,
  GET_QUOTE_FUNNELS_PRICES_SUCCESS,
  GET_QUOTE_FUNNELS_PRICES_ERROR,

} from "./actionTypes"

const INIT_STATE = {
  quote_funnels_prices: [],
  error: null,
  loading: false,
}
const QuoteFunnelsPrices = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QUOTE_FUNNELS_PRICES:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_QUOTE_FUNNELS_PRICES_SUCCESS:
      return {
        ...state,
        error: null,
        quote_funnels_prices: action.payload,
        loading: false,

      }

    case GET_QUOTE_FUNNELS_PRICES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,

      }

    default:
      return state
  }
}

export default QuoteFunnelsPrices
